/*import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, Observable, switchMap, tap } from 'rxjs';
import { StorageService } from '../storage-service/storage.service';

@Injectable({
  providedIn: 'root'
})
export class TarefaService {
  private apiUrl: string = ''; // Inicializa apiUrl como uma string vazia

  constructor(private http: HttpClient, private storageService: StorageService) {
    this.initApiUrl(); // Chama o método para inicializar a URL da API ao criar o serviço
  }

  // Método para inicializar a URL da API, buscando no IndexedDB
  private async initApiUrl() {
    try {
      // Recupera a URL do servidor (apiUrl) do IndexedDB
      const servidor = await this.storageService.getServidor();

      if (servidor && servidor.url_servidor) {
        this.apiUrl = `${servidor.url_servidor}/folha-servico`; // Define a URL completa da API
       //console.log('API URL definida para:', this.apiUrl);
      } else {
        // Caso não tenha a URL salva, define um valor padrão
        this.apiUrl = 'https://i9fluir.com.br:8082/api/folha-servico';
       //console.log('Nenhuma URL encontrada, usando a URL padrão:', this.apiUrl);
      }
    } catch (error) {
      console.error('Erro ao buscar a URL da API no IndexedDB:', error);
      // Define uma URL padrão em caso de erro
      this.apiUrl = 'https://i9fluir.com.br:8082/api/folha-servico';
    }
  }

iniciarTarefa(id: number, horaInicio: string, latitude: number, longitude: number): Observable<any> {
  return from(this.initApiUrl()).pipe(
    switchMap(() => {
      const body = {
        id: id,
        horaInicio: horaInicio,
        latitude_tarefa_inicio: latitude,
        longitude_tarefa_inicio: longitude
      };

      return this.http.post<any>(`${this.apiUrl}/iniciar-tarefa`, body).pipe(
        tap((resposta) => {
       //console.log('Resposta completa recebida:', JSON.stringify(resposta));
       //console.log('ID retornado pelo backend:', resposta?.id);
      })
      );
    })
  );
}


  // Método para finalizar a tarefa
  finalizarTarefa(
    id: number,
    horaFim: string,
    hodometroFinal: number,
    catracaFinal: number,
    latitude: number,
    longitude: number
  ): Observable<any> {
    return from(this.initApiUrl()).pipe(
      switchMap(() => {
        const body = {
          id,
          horaFim,
          hodometroFinal,
          catracaFinal,
          latitude_tarefa_fim: latitude,
          longitude_tarefa_fim: longitude
        };
        return this.http.post(`${this.apiUrl}/finalizar-tarefa`, body);
      })
    );
  }

  // Método para cancelar a tarefa
  cancelarTarefa(
  id: number,
  horaFim: string,
  motivoCancelamento: string,
  latitude: number,
  longitude: number
  ): Observable<any> {
    return from(this.initApiUrl()).pipe(
      switchMap(() => {
        const body = {
          id,
          horaFim,
          motivoCancelamento,
          latitude_tarefa_fim: latitude,
          longitude_tarefa_fim: longitude
        };
        return this.http.post(`${this.apiUrl}/cancelar-tarefa`, body);
      })
    );
  }

}*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TarefaService {

  constructor(private http: HttpClient) {}

  iniciarTarefa(
    id: number,
    horaInicio: string,
    latitude: number,
    longitude: number
  ): Observable<any> {

    const body = {
      id,
      horaInicio,
      latitude_tarefa_inicio: latitude,
      longitude_tarefa_inicio: longitude
    };

    return this.http.post(`/folha-servico/iniciar-tarefa`, body);
  }

  finalizarTarefa(
    id: number,
    horaFim: string,
    hodometroFinal: number,
    catracaFinal: number,
    latitude: number,
    longitude: number
  ): Observable<any> {

    const body = {
      id,
      horaFim,
      hodometroFinal,
      catracaFinal,
      latitude_tarefa_fim: latitude,
      longitude_tarefa_fim: longitude
    };

    return this.http.post(`/folha-servico/finalizar-tarefa`, body);
  }

  cancelarTarefa(
    id: number,
    horaFim: string,
    motivoCancelamento: string,
    latitude: number,
    longitude: number
  ): Observable<any> {

    const body = {
      id,
      horaFim,
      motivoCancelamento,
      latitude_tarefa_fim: latitude,
      longitude_tarefa_fim: longitude
    };

    return this.http.post(`/folha-servico/cancelar-tarefa`, body);
  }
}